import { render } from "./AnnouncementHeader.vue?vue&type=template&id=d94e7cd6&scoped=true"
const script = {}

import "./AnnouncementHeader.vue?vue&type=style&index=0&id=d94e7cd6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d94e7cd6"]])

export default __exports__